<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading">
            <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
                <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
                <a-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" :xxl="15">
                    <a-form :form="form" layout="horizontal" style="margin-top: 20px">
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="药品名称" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{drug.name}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col span="16">
                                <a-form-item label="别名" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                    <span>{{drug.alias}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="药品类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{drug.typeName}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="规格" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{drug.spec}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="剂型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{drug.formName}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="销售单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{null!=drug.salesUnit ? drug.salesUnit.name : ''}}</span>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="销售单价" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{drug.price}}</span>元
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item  label="推荐剂量" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span>{{null!=drug.dosage ? drug.dosage.start : ''}}-{{null!=drug.dosage ? drug.dosage.end : ''}}{{(null!=drug.dosage && null!=drug.dosage.unit) ? drug.dosage.unit.name : ''}}</span>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                          <a-col span="8">
                            <a-form-item label="库存量" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                              <span>{{drug.stockQty||''}}</span>
                            </a-form-item>
                          </a-col>
                          <a-col span="8">
                            <a-form-item label="成本价" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                              <span>{{null==drug.cost ? '' : drug.cost+'元'}}</span>
                            </a-form-item>
                          </a-col>
                        </a-row>
                        <a-row>
                            <a-col span="24">
                                <a-form-item :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
                                    <span slot="label">是否允许拆零销售</span>
                                    <div style="width: 100%;display: flex;flex-direction: row">
                                        <a-checkbox :checked="record.minUnitCustom" @change="minUnitChange" ></a-checkbox>
                                        <div style="width: 100%" v-if="record.minUnitCustom">
                                            <a-input style="width: 100px;margin-left: 10px" v-decorator="['minUnit', {rules: [{ required: true, message: '药品拆零单位必须填写!' }], initialValue: (null !=drug.minUnit ? drug.minUnit.name : '') }]" @change="minUnitValueChange" placeholder="拆零单位"/>/
                                            <a-input style="width: 100px;margin-left: 10px" v-decorator="['unitRatio', {rules: [{ required: true, message: '换算比例必须填写!' }], initialValue: (null!=drug.salesUnit ? drug.salesUnit.rate : 0) }]" placeholder="换算比例"/>
                                            <span style="margin-left: 10px;margin-right: 10px;color: rgba(0, 0, 0, 0.85)">拆零单价:</span>
                                            <a-input-number :min="0" v-decorator="['minPrice', {rules: [{ required: true, message: '药品拆零单价必须填写!' }], initialValue: drug.minPrice }]" placeholder="拆零单价"/>元
                                            <span style="margin-left: 10px;color: #ff0000">注：每销售单位 =每拆零单位 *换算比例</span>
                                        </div>
                                        <div style="width: 100%;margin-left: 10px;color: #ff0000" v-if="!record.minUnitCustom">如果当前销售单位无法满足本机构销售需要，可配置拆零销售</div>
                                    </div>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="发票类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-select v-decorator="['invoiceId', {rules: [{ required: true, message: '发票类型必须填写!' }], initialValue: drug.invoiceId }]" placeholder="请选择发票类型">
                                        <a-select-option v-for="item in init.invoices" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col span="16">
                                <a-form-item  label="生产厂家" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                    <a-input v-decorator="['manufacturer', {initialValue: drug.manufacturer }]" placeholder="请输入生产厂家"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="批准文号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-input v-decorator="['approval', {initialValue: drug.approval }]" placeholder="请输入批准文号"/>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="药品条码" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-input v-decorator="['barCode', {rules: [{ required: false, message: '药品条码必须填写!' }], initialValue: drug.barCode }]" placeholder="请输入药品条码"/>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="库存预警值" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-input-number :min="0" v-decorator="['alert', {rules: [{ required: false, message: '库存预警值必须填写!' }], initialValue: drug.alert }]" placeholder="请输入库存预警值"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row v-if="record.type=='CM' && record.drugForm == 'PIECES'">
                          <a-col span="2"></a-col>
                          <a-col span="22">
                            <a-tabs default-active-key="1" size="small" style="min-height: 260px;">
                              <a-tab-pane key="1" tab="可替换药品">
                                <a-table size="small" :columns="insteadGrid.columns" rowKey="index" bordered :data-source="insteadGrid.datas" :pagination="false" style="padding:4px;">
                                  <a-form-item slot="insteadDrugSlot" slot-scope="text, instRecord, index"  style="margin-bottom: 1px!important;">
                                    <a-auto-complete placeholder="请输入药品名称检索" v-model="instRecord.id" option-label-prop="label" @search="value => instendDrugSearch(value, index)" @select="value => instendDrugSelect(value, index)" :dropdown-match-select-width="false" style="width: 100%;">
                                      <template slot="dataSource">
                                        <a-select-option v-for="item in instends" :key="'instead-'+(index + 1)+'-'+item.id" :label="item.name" :value="item.id">
                                          <a-row>
                                            <a-col span="8">
                                              {{ item.name }}
                                            </a-col>
                                          </a-row>
                                        </a-select-option>
                                      </template>
                                    </a-auto-complete>

                                  </a-form-item>
                                  <a-form-item slot="sourceUnitSlot" slot-scope="text, instRecord"  style="margin-bottom: 1px!important;">
                                    <a-select style="width: 80px" v-model="instRecord.sourceUnit" placeholder="请选择推荐剂型单位">
                                      <a-select-option v-for="item in record.units" :key="item" :value="item">{{item}}</a-select-option>
                                    </a-select>
                                  </a-form-item>
                                  <a-form-item slot="sourceQtySlot" slot-scope="text, instRecord" style="margin-bottom: 1px!important;">
                                    <a-input-number :min="0.01" :step="1" v-model="instRecord.sourceQty" />
                                  </a-form-item>
                                  <a-form-item slot="targetUnitSlot" slot-scope="text, instRecord"  style="margin-bottom: 1px!important;">
                                    <a-select style="width: 80px" v-model="instRecord.targetUnit" placeholder="请选择推荐剂型单位">
                                      <a-select-option v-for="item in instRecord.targetUnits" :key="item.name" :value="item.name">{{item.name}}</a-select-option>
                                    </a-select>
                                  </a-form-item>
                                  <a-form-item slot="targetQtySlot" slot-scope="text, instRecord" style="margin-bottom: 1px!important;">
                                    <a-input-number :min="0.01" :step="1" v-model="instRecord.targetQty" />
                                  </a-form-item>
                                  <span slot="Operate" slot-scope="text, instRecord, index">
                                                     <a href="javascript:;" @click="()=>deleteInsteadAction(index)">删除</a>
                                                </span>
                                </a-table>
                              </a-tab-pane>
                              <a-button slot="tabBarExtraContent" type="primary" ghost @click="addInsteadAction">添加药品</a-button>
                            </a-tabs>
                          </a-col>
                      </a-row>
                    </a-form>
                    <div class="button-container">
                        <div>
                            <a-button icon="double-left" style="float:right; margin-left: 24px;" @click="goBack">返回</a-button>
                            <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>saveDrug()">保存</a-button>
                        </div>
                    </div>
                </a-col>
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :xxl="8">&nbsp;</a-col>
            </a-row>
        </a-spin>
    </div>
</template>

<script>
  export default {
    name: "DrugHqEdit",
    data(){
      return{
        loading : false,
        form: this.$form.createForm(this),
        init: {
          invoices:[],

        },
        drug:{},                        //药品对象
        instends:[],                    //可替换药品查询返回的临时药品
        record:{
          name:'',                      //本药品名称
          type:'',                      //药品类型
          drugForm:'',                  //剂型

          saleUnit : '',                //销售单位
          minUnit : '',                 //最小单位
          units:[],                     //药品单位列表
          minUnitCustom : false,        //是否开启最小单位
        },

        insteadGrid:{
          columns: insteadColumn,
          datas: []
        },
      }
    },
    mounted() {
      let self = this;

      this.getInvoiceTypes(function (res) {
        self.init.invoices = res;
      })

      let id = this.$route.query.id;
      this.$axios.get('/api/clinic/drug/'+id).then(function(res){
        if(res.msg.flag == 0 && res.biz!=null){
          self.drug = res.biz;
          console.info(self.drug);

          //推荐剂量
          let _units = [];
          if(null !=self.drug.salesUnit){
            self.record.saleUnit = self.drug.salesUnit.name;
            _units.push(self.record.saleUnit);
            if(self.drug.scattered){
              self.record.minUnitCustom = true;
              if(self.drug.minUnit!=null){
                _units.push(self.record.minUnit.name);
              }
            }
          }
          self.record.units = _units;

          self.record.type = self.drug.type;
          self.record.drugForm = self.drug.form;
          if(self.drug.insteads != null && self.drug.insteads.length>0){

            let insteads = [];
            let list = [];      //table中的药品选项列表
            for(let instead of self.drug.insteads){
              insteads.push({id:instead.id, name:instead.name, type:instead.type, form:instead.form, sourceUnit:instead.sourceUnit.name, sourceQty:instead.sourceQty,
                targetUnit:instead.targetUnit.name, targetQty:instead.targetQty, targetUnits:[instead.targetUnit]});
              list.push({id:instead.id, name:instead.name});
            }
            self.instends = list;
            self.insteadGrid.datas = insteads;

          }
        }
      });

    },

    methods:{

      /**
       * 是否开启最小单位
       */
      minUnitChange:function(e){
        this.record.minUnitCustom = e.target.checked;
      },

      /**
       * 最小单位变更
       * @param e
       */
      minUnitValueChange:function(e){
        this.record.minUnit = e.target.value;
        let units = [];
        if(this.record.saleUnit!=''){
          units.push(this.record.saleUnit);
        }
        if(this.record.minUnit!=''){
          units.push(this.record.minUnit);
        }
        this.record.units = units;
      },

      //添加可替换药品
      addInsteadAction:function(){
        this.insteadGrid.datas.push({id:'', name:'', type:null, form:'', sourceUnits:[], sourceUnit:null, sourceQty:0, targetUnits:[], targetUnit:null, targetQty:null})
      },
      //删除可替换药品
      deleteInsteadAction:function(index){
        this.insteadGrid.datas.splice(index, 1);
      },
      //可替换药品查询
      instendDrugSearch:function(value, index){
        const self = this;
        self.instends = [];
        if(undefined != value && null != value && '' != value && value.length > 1){
          this.$axios.get('/api/clinic/drug/granules', {params:{owner:'HQ',keyword:value}}).then(function (res) {
            if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
              res.biz.forEach(function (e) {
                self.instends.push({id:e.id, name:e.name, units:e.units, type:e.type, form:e.form});
                console.info(self.instends)
              });
            }
          }, function (res) {
          });
        }
      },
      //可替换药品选中事件
      instendDrugSelect:function(value, index){
        let self = this;
        this.insteadGrid.datas.forEach(function (e, i) {
          if(i != index && e.id == value){
            self.$message.error({content:'不能添加重复的药品'});
            return;
          }
        })
        this.instends.forEach(function (e, i) {
          if(e.id == value){
            let drug = self.insteadGrid.datas[index];
            drug = Object.assign(drug,{drug:e, id:e.id, name:e.name, targetUnits:e.units});
            self.insteadGrid.datas[index] = drug;
          }
        });
        self.addInsteadAction();
      },

      saveDrug:function () {
        let self = this;
        this.form.validateFields((err, values) => {
          if(!err){
            let params = {barCode:values.barCode||'', manufacturer:values.manufacturer||'', approval:values.approval||'', invoiceId:values.invoiceId, minPrice : values.minPrice, alert:values.alert };

            if(self.record.minUnitCustom){
              params.minUnit = {name:values.minUnit, rate: 1 }
              params.rate = values.unitRatio;
              params.scattered = true;
            }else{
              params.scattered = false;
            }

            if(self.record.type=='CM' && self.record.drugForm == 'PIECES' && self.insteadGrid.datas.length>0){
              let insteads = [];
              let _sourceUnit = {};
              let _targetUnit = {};
              for(let instead of self.insteadGrid.datas){
                if(instead.id != null && instead.id!=''){
                  if(instead.sourceUnit==null|| instead.sourceUnit == ''){
                    self.$message.error({content:'可替换药品中当前药品单位不能为空'});
                    return;
                  }
                  if(instead.sourceQty==null|| instead.sourceQty == ''){
                    self.$message.error({content:'可替换药品中当前药品剂量不能为空'});
                    return;
                  }
                  if(instead.targetUnit==null|| instead.targetUnit == ''){
                    self.$message.error({content:'可替换药品中当前药品单位不能为空'});
                    return;
                  }
                  if(instead.targetQty==null|| instead.targetQty == ''){
                    self.$message.error({content:'可替换药品中当前药品剂量不能为空'});
                    return;
                  }

                  if(self.drug.salesUnit.name == instead.sourceUnit){
                    _sourceUnit = self.drug.salesUnit;
                  }else{
                    _sourceUnit = self.drug.minUnit;
                  }

                  for(let unit of instead.targetUnits){
                    if(instead.targetUnit == unit.name){
                      _targetUnit = unit;
                    }
                  }
                  insteads.push({drugId :instead.id, targetUnit : _targetUnit, targetDosage:instead.targetQty, sourceUnit : _sourceUnit, sourceDosage: instead.sourceQty})
                }

              }
              params.insteads = insteads;
            }

            params.id = self.drug.id;
            self.loadTip='正在保存药品信息,请稍候...';
            self.loading = true;
            self.$axios.post('/api/clinic/drug/hq/modify', params).then(function(res){
              self.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '药品保存成功.', duration: 2});
                self.form.resetFields();
                self.goBack();

              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            },function(res){
              self.loading = false;
            });
          }else{
            if(err!=null){
              let i = 0;
              for(let item in err){
                if(i == 0 && err[item].errors!=null && err[item].errors.length>0)
                  self.$message.error({content: err[item].errors[0].message, duration: 2});
                i++;
              }
            }
          }
        });
      },

      goBack:function (){
        this.$router.push({ path : '/layout/pharmacy/drug' });
      }
    }
  }

  const insteadColumn = [
    {
      title: '替换药品',
      key: 'id',
      align: 'center',
      width: 200,
      scopedSlots:{customRender:'insteadDrugSlot'}
    },{
      title: '当前药品',
      children:[
        {
          title: '单位',
          key: 'sourceUnit',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'sourceUnitSlot'}
        },
        {
          title: '剂量',
          key: 'sourceQty',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'sourceQtySlot'}
        }
      ]

    },{
      title: '替换药品',
      children:[
        {
          title: '单位',
          key: 'targetUnit',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'targetUnitSlot'}
        },
        {
          title: '剂量',
          key: 'targetQty',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'targetQtySlot'}
        }
      ]

    },{
      title: '操作',
      align: 'center',
      key: 'Operate',
      width: 80,
      scopedSlots: { customRender: 'Operate'}
    }
  ]

</script>

<style scoped>

</style>
